<div class="example-container mat-elevation-z8" >
    <div class="example-header rightPadding">
        <mat-form-field floatPlaceholder="never" class="expand">
            <input matInput #filter placeholder="Filter Actions by type">
        </mat-form-field>
    </div>
    <mat-table #table [dataSource]="dataSource">
        <ng-container matColumnDef="TypeAsString">
            <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
            <mat-cell *matCellDef="let row" > {{row.TypeAsString}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SMU">
            <mat-header-cell *matHeaderCellDef> SMU/Hourmeter </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.SMU}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="LTD">
            <mat-header-cell *matHeaderCellDef> LTD </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.LTD}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="DateAsStr">
            <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.DateAsStr}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Cost">
            <mat-header-cell *matHeaderCellDef> Cost </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.Cost}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Comment">
            <mat-header-cell *matHeaderCellDef> Comment </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row.Comment}} </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" class="hand-pointer" (click)="rowClicked(row)"></mat-row>
    </mat-table>

    <mat-paginator #paginator
                  [length]="eqTableDatabase.data.length"
                  [pageIndex]="0"
                  [pageSize]="25"
                  [pageSizeOptions]="[5, 10, 25, 100]">
    </mat-paginator>
    <div *ngIf="!ActionsLoaded">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>
